import { ConsoleLogger } from '@proposify/frontend-observability';
import { useCallback } from 'react';

export const scrollToSection = (id: string) => {
  const lazyLoadedSection = document.getElementsByClassName(`lazy-loaded-section-${id}`)[0] as HTMLElement;
  if (!lazyLoadedSection) return;

  if (!lazyLoadedSection.style.scrollMarginTop) {
    const headerHeight = document.getElementsByClassName('editor-header-wrapper')[0]?.clientHeight || 0;
    ConsoleLogger.log(`setting scroll margin top of ${headerHeight}px to .lazy-loaded-section-${id}`);
    lazyLoadedSection.style.scrollMarginTop = `${headerHeight}px`;
  }

  lazyLoadedSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

// TODO: try hack where scroll is called twice, to deal with the lazy loading that changes the height
// trigger that scroll once the active section becomes the given id?
export const useScrollToSection = () => useCallback((id: string) => scrollToSection(id), []);
